import { useState } from 'react';

import { AddContactForm } from './AddContact/AddContactForm';
import { ATSConnectHiringRequestCreateReferenceContactIds } from 'data-testids/ATS';
import { CurrentReferenceCreatePane, ReferencePaneProps } from '../../types/referenceTypes';
import { Reference } from 'types';
import { ReferenceCreateLandingPage } from './LandingPage/ReferenceCreateLandingPage';
import { SuccessSnackbar } from 'sharedComponents/Snackbar';
import { HiringRequestToastType } from '../../types';

export const ReferencePane: React.FC<ReferencePaneProps> = ({
  candidateId,
  candidateName,
  hiringRequestId,
  onCancel,
  onSuccess,
}) => {
  const [currentReferencePane, setCurrentReferencePane] =
    useState<CurrentReferenceCreatePane>('landingPage');
  const [shouldShowSuccessToast, setShouldShowSuccessToast] = useState(false);
  const [newReferenceContact, setNewReferenceContact] = useState<Reference>(null);

  const handleNewReferenceContactClick = () => setCurrentReferencePane('addContact');
  const handleModalClose = () => setShouldShowSuccessToast(false);
  const handleSetNewContact = (reference: Reference) => setNewReferenceContact(reference);

  const handleBackClick = (reference: Reference) => {
    setCurrentReferencePane('landingPage');
    setNewReferenceContact(reference);
  };
  const handleShowSuccessToast = () => setShouldShowSuccessToast(true);

  const handleSuccess = (type: HiringRequestToastType, message: string, isComplete?: boolean) => {
    onSuccess(type, message);
    if (isComplete) {
      onCancel();
    }
  };

  return (
    <>
      {currentReferencePane === 'landingPage' && (
        <ReferenceCreateLandingPage
          candidateName={candidateName}
          candidateId={candidateId}
          newReferenceContact={newReferenceContact}
          onAddClick={handleNewReferenceContactClick}
          onCancel={onCancel}
          onSuccess={handleSuccess}
          hiringRequestId={hiringRequestId}
        />
      )}
      {currentReferencePane === 'addContact' && (
        <AddContactForm
          candidateId={candidateId}
          onBackClick={handleBackClick}
          onCancel={onCancel}
          handleSetNewContact={handleSetNewContact}
          candidateName={candidateName}
          handleShowSuccessToast={handleShowSuccessToast}
        />
      )}
      <SuccessSnackbar
        open={shouldShowSuccessToast}
        onClose={handleModalClose}
        message="Successfully added reference contact"
        dataTestId={ATSConnectHiringRequestCreateReferenceContactIds.SUCCESS_TOAST}
      />
    </>
  );
};
